import { constructionAsset, constructionEquipment, constructionSafety } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '여러분은 보안과 감시에 대해 이야기할 때 대부분 카메라를 떠올리실 겁니다. 하지만 CCTV 시스템은 전통적인 카메라와 비교해 많은 발전을 거듭했습니다. 사물인터넷(IoT)과 엣지 컴퓨팅 시대에 CCTV는 단순히 영상을 녹화하는 것을 넘어 기업과 조직이 보안을 관리하고 데이터를 최적화하며 IT 인프라와 깊이 통합할 수 있는 고급 기술 솔루션으로 자리 잡았습니다. 이 글에서는 CCTV가 무엇인지, 그 유형과 현대 생활에서의 다양한 역할을 살펴보겠습니다.',
  keywords: 'CCTV, 감시 카메라, CCTV 시스템, 보안 CCTV, 원격 모니터링, AI CCTV',
  ogSite: 'CCTV란 무엇인가요? 디지털 시대의 유형과 역할',
  title: 'CCTV란 무엇인가요? 디지털 시대의 유형과 역할',
  ogUrl: 'https://orbro.io/blog/what-is-cctv?',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_HQL0uLdowBG1C-9w9Mxz9ISOcp8CHof4GzNDRmJUN7yRblaDArwg5ymJVi6wTACN0tDPCLfmwuA23NKXo8ud7uUsiHlFuIkNtWrtT0xprdpn7KzkPdKb3cNuJI11TIE6iu-qaxfwghPhDVFItxJhbw4PQlG7RtMhmg_tybRtaLD5M2rDYokR6IxRbwU-CxeczVMb7I5fUrc90sTlWht7z3jmNZmnLUZc7MIJiPfMxpprEx19DhPOYUDKZrhFB5GSdUi9AhU2VguKbpPXMiXBWfM4BHZB7ugFfGCwzgaj2UqFyPRBBY9lGrpIvsmSa_np4ZqQAJWWGAqftTcyHSlU4nTCcM6cYgNdSWzlVjDxqdz_GpJs1hhU1q0IVrYPLOG8fo2JCh2UxC2tAxJYy_tjI-zjh0Hu97GogBk6nSVSG024v1rqAG3rZJOhk2BwVF6-1a2gTGCrv6lxn1WYLJIACOeh2koUGhXcPJbEUPcV8eq_S06DskK18rj1SsMK0nF7HHE6AirUDGl6tKmTmYDNFrn6KEYy5p9WMdi04M2IaoyCBuHnyftjpyC-HN6Lr3a0f479zS8GFaTGT4wdbBAC_WP4xho2d0QDkoqtWypHkDVQy2hrQxj5aEng0yddVf2hELf2WdFaJAdRfTl92VQ-0ql76cmPQfSq8z8Gbeb18yywOGlCHmdIE-QKNTv-hSZ8COxflykHi41c6-UVJONtZXVnASw_83MxtQ-e91EmstTIp0F9j7Y248xg-HXcLWa1-r8JRi2eUDcLwz2QQk39gng0MRpe0hPzOg8HLYO9QHu_LoX3HvUZw2afF0FUIcjmiL9wRkvdgIwjHcggmTaEAB48Gmde_JNfcL_JgebsETRc9HgA5INv9l9aqHE6dibjROAqZyCxp3PCzCThkQMSG201XzB-o_rwRqGUDOTx8or2EgggpLHH5cB_Ev2hDvTXKSYkADuSa1gzXl7sxV39PO5lhBVAzR6bUBjfTpQ1N7gNLEAInqjLJmadCSL04XZmo3gOtxRpEn33y2U8jj0rWUTmB3HhYtm7GtE4pPU6Bm78lc9JVA2GGuHwNTFuHhw8o5nQ4NXJa11N1ggNqVsGN6wRNTMC9aj7yJ77HF1c7wkLSw80RI83RMuixfWeq5X2by-z880c2_wEN3ZvVdoGJKPNj1uxMh-3pp820q8jE-L-79ADKJxME9SBeZLYvp8Os2lqF8wr6PNtytmdhHz5McqTAOVlzQJyTDWk4kO1X7WVmHLCYfvfnpUhkuk1l-OfDRbWhsB7G1Cdcw_YtKDNezSqTstWBXlc21Q6_iFrX5W134mrnJm0j682HrOxK-CXQwFCqO-GM1cUd6QW5OcOh5B-3i1NVQmWR_7EHyXbMHLDh2j53vqZb613IY2QdqDFQjzXFXLsUfAF8KPS8RSxFTUMpqJh50NTDOw02oEBFU3n6UqbX9pQL3IvlpcLWwb6NE15FMckPS2pWB7Wyrc9irP57_4myIhzxno_E8tmIgZ3ZGVQUTwcXmF3vjzHAX58XSSiUUOo6gjwRlqNMPEGKWx6ckQnhoHkVL4hOnDZkDEFxmeR4X8uB-w8gZB-6hkgES26d8HnWHreo_Q8f7_IPn7M8bMV-pMKydJQ=w1430-h1412?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-06-27',
  tag1: '#CCTV',
  tag2: '#감시카메라',
  tag3: '#CCTV시스템',
  tag4: '#보안CCTV #원격모니터링 #AICCTV',
  text: [
    {
      head: '',
      subHead: '',
      desc: '여러분은 보안과 감시에 대해 이야기할 때 대부분 카메라를 떠올리실 겁니다. 하지만 CCTV 시스템은 전통적인 카메라와 비교해 많은 발전을 거듭했습니다. 사물인터넷(IoT)과 엣지 컴퓨팅 시대에 CCTV는 단순히 영상을 녹화하는 것을 넘어 기업과 조직이 보안을 관리하고 데이터를 최적화하며 IT 인프라와 깊이 통합할 수 있는 고급 기술 솔루션으로 자리 잡았습니다. 이 글에서는 CCTV가 무엇인지, 그 유형과 현대 생활에서의 다양한 역할을 살펴보겠습니다.',
      dot: ''
    },
    {
      head: 'CCTV란 무엇인가요?',
      subHead: '',
      desc: 'CCTV(Closed-Circuit Television), 즉 폐쇄회로 텔레비전은 내부 네트워크에서 작동하는 카메라와 녹화 장치로 구성된 시스템으로, 공개적으로 방송되지 않습니다. 신호를 넓은 공간으로 전송하는 대신, CCTV는 카메라, 녹화기(DVR/NVR), 모니터 또는 관리 소프트웨어 간에 비디오 전송을 제한하여 보안과 집중도를 보장합니다.\n\n오늘날 CCTV의 본질은 다음과 같은 생태계로 구성됩니다:\n\nIP/아날로그 카메라: 다양한 해상도로 녹화하며, IR, PTZ, 온보드 AI를 지원합니다.\n\nDVR/NVR 녹화기: 영상을 녹화, 인코딩, 저장, 전송합니다.\n\n네트워크 인프라: 동축/이더넷 케이블 또는 Wi-Fi, 5G를 통해 연결을 보장합니다.\n\n소프트웨어/VMS(비디오 관리 시스템): 모니터링, 분석, 경고, 사용자 관리를 위한 중앙 허브입니다.',
      dot: ''
    },
    {
      head: '현대 CCTV의 유형',
      subHead: '',
      desc: '연결 표준에 따른 유형\n아날로그 CCTV: 동축 케이블을 사용하고 DVR과 결합되며, 비용이 저렴하지만 해상도에 제한이 있습니다.\nIP CCTV: LAN/Wi-Fi 네트워크를 사용하며, 디지털 카메라가 NVR 또는 클라우드로 신호를 전송하여 유연하게 확장할 수 있습니다.\n\n스마트 기능에 따른 유형\nAI 카메라: 얼굴 인식, 비정상적인 움직임 감지, 사람 counting 기능을 제공합니다.\nHDR/WDR 카메라: 역광 처리를 통해 모든 조명 조건에서 세부 사항을 보장합니다.\n전문 보안 카메라: 충격 방지, 방수(IP66/IP67) 기능을 갖추어 가혹한 환경에 적합합니다.\n\n구현 방식에 따른 유형\n온프레미스 CCTV: 현장에 설치되며, 데이터가 녹화기/NAS에 저장되어 엄격한 통제가 필요한 곳에 적합합니다.\n클라우드 CCTV: 카메라가 인터넷에 연결되어 클라우드에서 비디오를 저장하고 분석하며, 언제 어디서나 원격 접근을 지원합니다.\n엣지 CCTV: 카메라 또는 엣지 디바이스에서 AI를 처리하여 대역폭 부하와 지연을 줄입니다.',
      dot: ''
    },
    {
      head: 'IT와 일상 생활에서 CCTV의 역할',
      subHead: '',
      desc: '네트워크 및 물리적 보안 통합\n기업 환경에서 CCTV는 점점 더 SIEM(보안 정보 및 이벤트 관리) 및 접근 제어 시스템과 API를 통해 통합되고 있습니다. AI 카메라가 침입이나 이상 행동을 감지하면 보안 로그에 이벤트가 기록되고, SOC 팀에 경고가 전달되며 자동으로 문이 잠깁니다.\n\nIoT 및 스마트 기기 감시\nCCTV는 IoT 허브와 연결되어 기계나 생산 라인을 모니터링합니다. 카메라는 진동이나 비정상적인 온도를 감지하고, MQTT와 웹훅을 통해 자동으로 기계를 중지하거나 경고를 보냅니다.\n\n비디오 분석 및 빅데이터\n현대 VMS 시스템은 비디오에서 메타데이터(예: 시간, 위치, 움직임, 사람 수)를 수집하고 빅데이터로 전송하여 히트맵 분석, 고객 유동량 예측, 소매 또는 생산 공간의 최적화를 지원합니다.\n\n스마트 시티 응용\nCCTV는 가로등, 다리, 공공 건물에 설치되어 교통을 모니터링하고, 차량을 counting하며, 교통 체증을 감지하고 신호등을 자동으로 조정합니다. 데이터는 모바일 앱과 공공 전광판을 통해 시민과 공유됩니다.\n\n원격 의료 및 건강 관리\n병원은 환자 방에 카메라를 설치하고 AI를 통해 움직임을 분석하여 낙상이나 위험 신호를 감지합니다. 영상은 HIPAA/GDPR을 준수하여 암호화되며 개인정보를 보호합니다.',
      dot: ''
    },
    {
      head: '스마트 CCTV 구현의 이점',
      subHead: '',
      desc: '다층 보안 강화: 물리적 및 네트워크 보안이 통합되어 범죄를 억제합니다.\n\n효과적인 원격 모니터링: 모든 이벤트와 비디오는 휴대폰이나 웹 앱에서 접근할 수 있습니다.\n\n인프라 및 비용 최적화: 엣지 컴퓨팅으로 대역폭을 줄이고, 클라우드 스토리지로 유연성을 확보합니다.\n\n스마트 분석: AI와 빅데이터가 마케팅 및 운영을 위한 인사이트를 제공합니다.\n\n표준 준수: ISO 27001, GDPR, PCI DSS를 쉽게 충족할 수 있도록 비디오 저장 및 암호화를 지원합니다.',
      dot: ''
    },
    {
      head: '결론',
      subHead: '',
      desc: '세계는 디지털화 시대에 접어들었으며, CCTV는 단순한 녹화 카메라를 넘어 IoT, AI, 엣지, 클라우드와 통합된 IT 인프라의 중요한 부분이 되었습니다. 스마트 CCTV를 구현함으로써 기업은 보안을 강화하고, 운영을 최적화하며, 데이터를 심층적으로 활용할 수 있습니다. 적합한 솔루션을 선택하여 4차 산업혁명 시대에 성장과 지속 가능한 발전의 기회를 놓치지 마세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/enterprise/construction/equipment',
      },
    ],
  },
};
